import RdSideMenu from '@/components/common/sideMenu/RdSideMenu.vue'
import MRD_RT_001 from '@/views/rd/MRD_RT_001.vue'
import MRD_RT_002 from '@/views/rd/MRD_RT_002.vue'
import MRD_RT_003 from '@/views/rd/MRD_RT_003.vue'
import MRD_RT_004 from '@/views/rd/MRD_RT_004.vue'
import MRD_RT_005 from '@/views/rd/MRD_RT_005.vue'
import MRD_DS_001 from '@/views/rd/MRD_DS_001.vue'
import MRD_DS_002 from '@/views/rd/MRD_DS_002.vue'
import DashboardLayout from '@/layoutPage/DashboardLayout.vue'

//레포트 & 데시보드 라우터
const reportRouter = [
    // {
    //     path : '/report',
    //     name : '',
    //     component: () => import('../views/report/AnnualPerf.vue')  ,
    //     redirect : '/manager/annualPerf',
        
    //     children : [
    //         {
    //             //ex ) 화면 : Yearly Perf. FCST
    //             path : '/annualPerf',
    //             name : 'annualPerf',
    //             component: () => import('../views/report/AnnualPerf.vue')  ,
    //         }

    //     ]
    // }  

    /* 화면명 : Yearly Perf. FCST  : MRD_RT_001  */
     {
        path: "/rd/MRD_RT_001", 
        name : 'MRD_RT_001',
        components: {
            default : MRD_RT_001,
            sideMenu : RdSideMenu
        },
        meta :{
            sideMenu : RdSideMenu,
            title: 'Yearly Performance FCST',
            IADepth: ['리포트&대시보드', '리포트', 'Yearly Performance FCST']
        },
    },

    /* 화면명 : BizPlan  : MRD_RT_002  */
    {
        path: "/rd/MRD_RT_002", 
        name : 'MRD_RT_002',
        meta :{
            sideMenu : RdSideMenu,
            title: 'Yearly Cashflow FCST',
            IADepth: ['리포트&대시보드', '리포트', 'Yearly Cashflow FCST']
        },
        components: {
            default : MRD_RT_002,
            sideMenu : RdSideMenu
        },
    },

    /* 화면명 : Monthly Invoice & Cash Flow  : MRD_RT_003  */
    {
        path: "/rd/MRD_RT_003", 
        name : 'MRD_RT_003',
        meta :{
            sideMenu : RdSideMenu,
            title: 'Monthly Revenue & Gross Margin',
            IADepth: ['리포트&대시보드', '리포트', 'Monthly Revenue & Gross Margin']
        },
        components: {
            default : MRD_RT_003,
            sideMenu : RdSideMenu
        },
    },

    /* 화면명 : Profit & Loss  : MRD_RT_004  */
    {
        path: "/rd/MRD_RT_004", 
        name : 'MRD_RT_004',
        meta :{
            sideMenu : RdSideMenu,
            title: 'Pipeline Hygiene',
            IADepth: ['리포트&대시보드', '리포트', 'Pipeline Hygiene']
        },
        components: {
            default : MRD_RT_004,
            sideMenu : RdSideMenu
        },
    },

    /* 화면명 : Cash Flow  : MRD_RT_005  */
    {
        path: "/rd/MRD_RT_005", 
        name : 'MRD_RT_005',
        meta :{
            sideMenu : RdSideMenu,
            title: 'Payment',
            IADepth: ['리포트&대시보드', '리포트', 'Payment']
        },
        components: {
            default : MRD_RT_005,
            sideMenu : RdSideMenu
        },
    },

    
    /* 화면명 : 대쉬보드1  : MRD_DS_001  */
    {
        path: "/rd/MRD_DS_001", 
        name : 'MRD_DS_001',
        meta :{
            sideMenu : RdSideMenu,
            title: '대시보드1',
            IADepth: ['리포트&대시보드', '대시보드', '대시보드1']
        },
        components: {
            default : MRD_DS_001,
            sideMenu : RdSideMenu
        },
    },

    
    /* 화면명 :  대쉬보드2 : MRD_DS_002  */
    {
        path: "/rd/MRD_DS_002", 
        name : 'MRD_DS_002',
        meta :{
            layout: DashboardLayout,
            title: '대시보드',
            IADepth: ['리포트&대시보드', '대시보드', '대시보드']
        },
        components: {
            default : MRD_DS_002,
            sideMenu : RdSideMenu
        },
    }

]
export {reportRouter}